import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CheckboxCircleArrowIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CheckboxCircleArrowIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CheckboxCircleArrowIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CheckboxCircleArrowIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="CheckboxCircleArrowIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12q0-.507.05-1h2.012A8 8 0 1 0 12 4zm3.607 7.707a1 1 0 0 1 0 1.414l-3.657 3.657a1 1 0 0 1-1.414 0L8.707 12.95a1 1 0 1 1 1.414-1.414l1.12 1.12 2.951-2.949a1 1 0 0 1 1.415 0M5 1l5 4-5 4V6H2V4h3z"
        clipRule="evenodd"
      />
    </svg>
  )
);
CheckboxCircleArrowIcon.displayName = "CheckboxCircleArrowIcon";
export default CheckboxCircleArrowIcon;
